export const iconFontAwesomeSecurityLockOpen = (
	<i className="fa-solid fa-lock-open"></i>
);
